import { Step } from 'react-joyride';

const getAppointmentsTourSteps = (isMobile: boolean): Step[] => {
  const allSteps: (Step & { desktopOnly?: boolean })[] = [
    {
      target: '.tour-title',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Bienvenido a la sección de <strong>Citas</strong>. Aquí consultas,
          filtras, buscas y exportas todas las reservas que han hecho tus
          clientes.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-date-filters',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Usa estos campos para <strong>elegir un rango de fechas</strong> y ver
          solo las citas comprendidas entre esos días. Por ejemplo, del 1 al 15
          de este mes.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-export-buttons',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si necesitas guardar o compartir la información, puedes{' '}
          <strong>exportar el listado</strong> en Excel o PDF. Se exporta
          exactamente lo que tengas filtrado en ese momento.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-search-input',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Aquí puedes <strong>buscar citas</strong> por nombre del trabajador,
          servicio prestado o teléfono del cliente.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-state-filters',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Filtra las citas por su <strong>estado</strong>: confirmadas,
          completadas, canceladas, anuladas, etc. Marca o desmarca cada casilla
          según lo que quieras ver.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '.tour-table-head',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Aquí se listan todas las <strong>citas que coinciden con tus
          filtros</strong>: cliente, servicio, trabajador, hora, precio y
          estado. Cada estado tiene su color para localizarlo de un vistazo.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '.tour-columns-button',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Desde aquí eliges <strong>qué columnas mostrar u ocultar</strong> en
          la tabla, para adaptarla a lo que más te interese ver.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: '.tour-pagination',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si hay muchas citas, usa la <strong>paginación</strong> para moverte
          entre páginas y ajustar cuántas ver a la vez.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
  ];

  return allSteps
    .filter((s) => !(isMobile && s.desktopOnly))
    .map(({ desktopOnly, ...step }) => step);
};

export default getAppointmentsTourSteps;